{
    "NAME": "ApparaatModaal",
    "DeviceModal_AddTitle": "Apparaat toevoegen",
    "DeviceModal_ChangeTitle": "Apparaat wisselen",
    "DeviceModal_ViewTitle": "Apparaat bekijken",
    "DeviceModal_PromptMessage": "U hebt niet-opgeslagen apparaatwijzigingen. Wilt u afsluiten zonder op te slaan?",
    "DeviceModal_PromptConfirm": "Uitgang",
    "DeviceModal_PromptCancel": "Annuleren",
    "DeviceModal_Tab_General": "Details",
    "DeviceModal_Tab_Advanced": "Geavanceerd",
    "DeviceModal_Tab_Monitoring": "Monitoring",
    "DeviceModal_Tab_DeviceMembers": "Apparaatleden",
    "DeviceModal_Tab_AgentMembers": "Agentleden",
    "DeviceModal_Tab_DnisMembers": "DNIS",
    "DeviceModal_Tab_LinkedEntities": "Gekoppelde entiteiten",
    "DeviceModal_Loading": "Laden...",
    "DeviceModal_Button_Close": "Dichtbij",
    "DeviceModal_Button_Cancel": "Annuleren",
    "DeviceModal_Button_Save": "Redden",
    "DeviceModal_RequestFailed": "Verzoek mislukt",
    "DeviceModal_General_IdentifierGuid": "Identificatiecode (GUID)",
    "DeviceModal_General_IdentifierPlaceholder": "[Automatisch toegewezen]",
    "DeviceModal_General_GuidPendingHelp": "De identificatiecode wordt toegekend nadat het apparaat is opgeslagen.",
    "DeviceModal_General_DeviceNumber": "Apparaatnummer",
    "DeviceModal_General_DeviceNumberRequired": "Apparaatnummer is vereist",
    "DeviceModal_General_Description": "Beschrijving",
    "DeviceModal_General_DescriptionRequired": "Een beschrijving is vereist.",
    "DeviceModal_General_DeviceType": "Apparaattype",
    "DeviceModal_General_DeviceTypeRequired": "Het apparaattype is vereist.",
    "DeviceModal_General_Partition": "Partitie",
    "DeviceModal_General_PartitionRequired": "Een partitie is vereist.",
    "DeviceModal_General_None": "Geen",
    "DeviceModal_General_IDOnTelSys": "ID op de telefonieserver",
    "DeviceModal_General_IDOnTelSys_Broadworks": "BroadWorks gebruikers-ID",
    "DeviceModal_General_IDOnTelSys_Webex": "Webex-oproepgebruikers-ID",
    "DeviceModal_General_IDOnTelSys_MsTeams": "MSTeams gebruikers-ID",
    "DeviceModal_General_IDOnTelSys_Panasonic": "ID op telefonieserver",
    "DeviceModal_General_IDOnTelSys_M6": "OID op telefoonserver",
    "DeviceModal_General_IDOnTelSysOwner": "Eigenaar Groeps-ID",
    "DeviceModal_General_IDOnTelSysDivision": "Verantwoordelijke afdeling (volledig pad)",
    "DeviceModal_General_InternalExtension": "Intern inbeladres",
    "DeviceModal_General_TelSysUserID": "Gebruikers-ID van de telefonieserver",
    "DeviceModal_General_TelSysUserID_WebexCiscoCommonIdentity": "Cisco Common Identity",
    "DeviceModal_General_TelSysUserID_MsTeamsUpnUrn": "Gebruikersprincipalnaam (URN)",
    "DeviceModal_General_TelSysPassword": "Wachtwoord voor de telefonieserver",
    "DeviceModal_General_TelSysMonitorPassword": "Monitorwachtwoord",
    "DeviceModal_General_PrimaryEmail": "Primair e-mailadres",
    "DeviceModal_General_UpdateExistingItems": "Werk bestaande items bij als er duplicaten worden gevonden.",
    "DeviceModal_Monitoring_OverrideMonitoring": "Monitoring overschrijven (niet gemonitord)",
    "DeviceModal_Monitoring_DisableRTMonitoring": "Realtime monitoring uitschakelen",
    "DeviceModal_Members_DeviceNumber": "Apparaatnummer",
    "DeviceModal_Members_Description": "Beschrijving",
    "DeviceModal_Members_AgentNumber": "Agentnummer",
    "DeviceModal_Members_Actions": "Acties",
    "DeviceModal_Members_Add": "Lid toevoegen",
    "DeviceModal_Members_AddHotkey": "Lid toevoegen (Ctrl+Enter)",
    "DeviceModal_Members_Remove": "Lid verwijderen",
    "DeviceModal_Members_Search": "Zoek leden",
    "DeviceModal_Members_NoDeviceMembers": "Geen apparaatleden",
    "DeviceModal_Members_NoAgentMembers": "Geen agenten",
    "DeviceModal_Members_DnisNumber": "DNS-nummer",
    "DeviceModal_Members_AddDnis": "Voeg DNS toe",
    "DeviceModal_Members_AddDnisHotkey": "DNIS toevoegen (Ctrl+Enter)",
    "DeviceModal_Members_NoDnisMembers": "Geen DNS-associaties",
    "DeviceModal_LinkedEntities_Loading": "Gekoppelde entiteiten laden…",
    "DeviceModal_LinkedEntities_Empty": "Geen",
    "DeviceModal_LinkedEntities_Section_Groups": "Groepslidmaatschappen",
    "DeviceModal_LinkedEntities_Section_Users": "Gerelateerde gebruikers",
    "DeviceModal_LinkedEntities_Column_GroupId": "Groep",
    "DeviceModal_LinkedEntities_Column_Description": "Beschrijving",
    "DeviceModal_LinkedEntities_Column_UserId": "Gebruiker"
}